import React from "react";
import { Link } from "react-router-dom";
import {
  LayoutDashboard, Wrench, FileText, BookOpen, Bell,
  Calendar, MessageSquare, HelpCircle, Image, Quote, Network,
} from "lucide-react";
import {
  Sidebar, SidebarHeader, SidebarContent, SidebarFooter,
  SidebarGroup, SidebarGroupLabel, SidebarGroupContent,
  SidebarMenu, SidebarMenuItem, SidebarMenuButton, SidebarMenuLabel,
  SidebarSeparator, useSidebar,
} from "../ui/sidebar";
import NavUser from "./NavUser";

const CONTENT_NAV = [
  { key: "dashboard",   icon: LayoutDashboard, label: "Dashboard" },
  { key: "service",     icon: Wrench,          label: "Services" },
  { key: "blogs",       icon: FileText,         label: "Blogs" },
  { key: "courses",     icon: BookOpen,         label: "Courses" },
  { key: "notices",     icon: Bell,             label: "Notices" },
  { key: "events",      icon: Calendar,         label: "Events" },
  { key: "queries",     icon: MessageSquare,    label: "Queries" },
  { key: "faqs",        icon: HelpCircle,       label: "FAQ's" },
  { key: "banners",     icon: Image,            label: "Banners" },
  { key: "testimonials",icon: Quote,            label: "Testimonials" },
];

const CRM_NAV = [
  { key: "crm", icon: Network, label: "CRM" },
];

export default function AppSidebar({ activeTab, onNavigate, onLogout }) {
  const { open } = useSidebar();

  return (
    <Sidebar>
      {/* Logo */}
      <SidebarHeader>
        <div className={`flex items-center gap-2.5 px-1 py-1 ${!open ? "justify-center" : ""}`}>
          <Link to="/" className="shrink-0">
            <img src="/logo_up.png" alt="Logo" className="h-8 w-8 rounded-md object-contain" />
          </Link>
          <SidebarMenuLabel className="text-[13px] font-bold text-gray-900">
            Smart Scholars 360
          </SidebarMenuLabel>
        </div>
      </SidebarHeader>

      {/* Nav */}
      <SidebarContent>
        {/* Content group */}
        <SidebarGroup>
          <SidebarGroupLabel>Manage Content</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {CONTENT_NAV.map(({ key, icon: Icon, label }) => (
                <SidebarMenuItem key={key}>
                  <SidebarMenuButton
                    isActive={activeTab === key}
                    onClick={() => onNavigate(key)}
                    tooltip={label}
                  >
                    <Icon className={`h-4 w-4 shrink-0 ${activeTab === key ? "text-blue-600" : "text-gray-400"}`} />
                    <SidebarMenuLabel>{label}</SidebarMenuLabel>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>

        <SidebarSeparator />

        {/* CRM group */}
        <SidebarGroup>
          <SidebarGroupLabel>Lead Management</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {CRM_NAV.map(({ key, icon: Icon, label }) => (
                <SidebarMenuItem key={key}>
                  <SidebarMenuButton
                    isActive={activeTab === key}
                    onClick={() => onNavigate(key)}
                    tooltip={label}
                  >
                    <Icon className={`h-4 w-4 shrink-0 ${activeTab === key ? "text-blue-600" : "text-gray-400"}`} />
                    <SidebarMenuLabel>{label}</SidebarMenuLabel>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>

      {/* User footer */}
      <SidebarFooter>
        <NavUser onLogout={onLogout} />
      </SidebarFooter>
    </Sidebar>
  );
}
